
import React from 'react';
import { Launch } from '@mui/icons-material';
import { useBuildDynamicUrl } from '../../../../hooks/useDynamicUrl';
import { useDrawerClickHandler } from '../../../../utils/drawerClickContext';

/**
 * CPI7 - HD-LW_Avg
 * Empty component used only for attaching static properties (actionTitle, actionContent)
 * Note: This KPI has no "More Info" content, only "Take Action" drawer
 */
interface CPI7Component extends React.FC {
  actionTitle?: string;
  actionContent?: React.FC;
}

const CPI7: CPI7Component = () => null;

/**
 * CPI7TakeAction - Take Action drawer content for CPI7 (HD-LW_Avg)
 * Displays Competitive Price Details in the action drawer
 */
const CPI7TakeAction: React.FC = () => {
  const buildDynamicUrl = useBuildDynamicUrl();
  const clickHandler = useDrawerClickHandler();

  const competitivePriceLinks = [
    { label: 'All Skus', urlCode: 'CPI_SKU' },
    { label: 'Discovery Department', urlCode: 'CPI_DEPT' },
    { label: 'Discovery Product Category', urlCode: 'CPI_PROD' },
    { label: 'Merchandise Class', urlCode: 'CPI_CLASS' },
    { label: 'Product Group', urlCode: 'CPI_GROUP' },
    { label: 'Vendor', urlCode: 'CPI_VENDOR' },
  ];

  return (
    <div style={{ padding: '16px' }}>
      {competitivePriceLinks.map((item, index) => {
        const url = buildDynamicUrl('WFC', item.urlCode);
        return (
          <div key={index} style={{ marginBottom: '12px' }}>
            <a
              href={url || '#'}
              target="_blank"
              rel="noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                color: '#E53935',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
              onClick={e => {
                if (clickHandler && url) {
                  e.preventDefault();
                  clickHandler(
                    `Take Action Drawer – Competitive Price Details - ${item.label}`,
                    { url },
                  );
                }
              }}>
              {item.label}
              <Launch fontSize="small" style={{ marginLeft: '4px', verticalAlign: 'middle' }} />
            </a>
          </div>
        );
      })}
    </div>
  );
};

CPI7.actionTitle = 'Competitive Price Details';
CPI7.actionContent = CPI7TakeAction;

export default CPI7;